import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Moon, Sun, MessageCircle, Lock } from "lucide-react";
import { LANDLORD } from "@/data/landlord";

export default function Header() {
  const [dark, setDark] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#EFF0F2]/85 dark:bg-[#12100E]/85 border-b border-[#E4DBD0]/80 dark:border-[#352F2B]/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 grid grid-cols-[1fr_auto_1fr] items-center gap-2">
        <div className="flex justify-start">
          <a
            data-testid="header-contact-btn"
            href={LANDLORD.phoneHref}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#A05A32] hover:bg-[#864522] text-[#EFF0F2] px-5 py-2.5 text-sm font-medium transition-colors"
          >
            <MessageCircle className="h-4 w-4" />
            {LANDLORD.phone}
          </a>
        </div>
        <Link to="/" data-testid="header-brand-link" className="flex justify-center">
          <img src="/logo.png" alt="Ricky Rooms Lettings" className="h-20 sm:h-28 w-auto" />
        </Link>
        <div className="flex items-center justify-end gap-2 sm:gap-3">
          <Link
            data-testid="header-admin-link"
            to="/admin"
            className="inline-flex items-center gap-1.5 rounded-full border border-[#E4DBD0] dark:border-[#352F2B] bg-white/60 dark:bg-transparent px-4 py-2.5 text-sm text-[#57524E] dark:text-[#C7BEB5] hover:bg-white dark:hover:bg-[#231F1C] transition-colors"
          >
            <Lock className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Owner</span>
          </Link>
          <button
            data-testid="header-theme-toggle"
            onClick={() => setDark((d) => !d)}
            aria-label="Toggle theme"
            className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-[#E4DBD0] dark:border-[#352F2B] bg-white/60 dark:bg-transparent text-[#57524E] dark:text-[#C7BEB5] hover:bg-white dark:hover:bg-[#231F1C] transition-colors"
          >
            {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>
        </div>
      </div>
    </header>
  );
}
